@if ($course()) {
    <meta-content-preview [contentType]="'course'" [cover]="$cover()" [title]="$title()"
        [duration]="$duration()" [description]="$description()" [skills]="$skills()"
        [banned]="$banned()" [students]="$students()" [updated]="$updated()"
        [showProgress]="$showProgress()" [lowerHeight]="$lowerHeight()" [showStudents]="$showStudents()"
        [showSkills]="$showSkills()" [showImage]="$showImage()" [showCompletedIcon]="$completed()"
        [showCertificateIcon]="$course()!.finalCertificate === true && $completedMandatory()"
        [showContentTypeIcon]="$showContentTypeIcon()" [showStarIcon]="$showStarIcon()"
        [showDescription]="$showDescription()"
        [showLockIcon]="$showLockIcon()"
        [progress]="$progress()" [mandatoryProgress]="$mandatoryProgress()" [mandatoryPercent]="$mandatoryPercent()"
        (click)="doClick.emit($event)"
        (clickCertificate)="$event.stopPropagation(); showCertificate()" />
}
